






















































import Vue from "vue";
import { TableLayout } from "@/layouts";
import { Header } from "@/components/MyTable.vue";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";

import Edit from "@/components/PrjMembers/Edit.vue";
import Invite from "@/components/PrjMembers/Invite.vue";

const PrjMembersHeaders: Header[] = [
  { title: "用户名", key: "userName" },

  { title: "用户角色", key: "roleDesc" },
  { title: "邀请人", key: "createBy" },
  { title: "创建时间", key: "createTime", minWidth: 180 },
  { title: "更新时间", key: "updateTime", minWidth: 180 },
  { title: "操作", key: "", width: 100 }
];
export default Vue.extend({
  name: "PrjMembers",
  components: { TableLayout, Edit, Invite },
  props: { projectId: { type: String }, tenantId: { type: String } },
  data() {
    return {
      PrjMembersHeaders,
      isInit: false
    };
  },
  computed: {
    ...mapState("PrjMembers", [
      "inviteList",
      "pages",
      "pageNum",
      "total",
      "filterValue",
      "loading",
      "hasNext"
    ]),
    ...mapGetters("PrjMembers", ["tableData"])
  },
  watch: {
    // 利用watch方法检测路由变化：
    $route: function(to, from) {
      // 每次跳转到项目成员页面都重新请求成员名单和邀请名单
      if (to.name === "PrjMembers") {
        this.getData({ projectId: this.projectId });
        this.invite({ tenantId: this.tenantId, projectId: this.projectId });
        this.isInit = true;
      }
      // 从当前页跳转到其他页面
      else if (from.name === "PrjMembers") {
        this.isInit = false;
      }
    }
  },
  mounted() {
    if (!this.isInit) {
      this.getData({ projectId: this.projectId });
      this.invite({ tenantId: this.tenantId, projectId: this.projectId });
    }
  },
  beforeDestroy() {
    this.clear();
  },
  methods: {
    ...mapActions("PrjMembers", ["invite", "getData", "delete", "turnPage"]),
    ...mapMutations("PrjMembers", { clear: "ClearStateMutation" }),
    inviteDialog() {
      (this.$refs.invite as any)?.show(this.inviteList);
    },
    edit(data: any) {
      (this.$refs.edit as any)?.show(data);
    },
    del(userId: string, name: string) {
      this.$confirms({ title: `删除 ${name}` }).then(() => {
        this.delete({
          userId: userId,
          tenantId: this.tenantId,
          projectId: this.projectId
        });
      });
    },
    searchUser(value: string) {
      this.getData({ projectId: this.projectId, append: value });
    },
    handleCommand(type: string, data: any) {
      switch (type) {
        case "edit":
          this.edit(data);
          break;

        case "delete":
          this.del(data.userId, data.userName);
          break;
      }
    }
  }
});
